import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'warning' | 'danger';

export type ToastPayload = {
  id: number;
  text: string;
  type: ToastType;
  duration: number;
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toast = signal<ToastPayload | null>(null);

  private toastId = 0;

  show(text: string, type: ToastType = 'success'): void {
    this.toastId += 1;
    this.toast.set({
      id: this.toastId,
      text,
      type,
      duration: this.calculateDuration(text, type),
    });
  }

  dismiss(): void {
    this.toast.set(null);
  }

  private calculateDuration(text: string, type: ToastType): number {
    if (type === 'success') {
      return 3000;
    }

    const calculated = 2000 + text.length * 50;
    return Math.min(Math.max(calculated, 5000), 8000);
  }
}
